import { useEffect } from "react";
import Navbar from "@/components/layout/Navbar";
import Footer from "@/components/layout/Footer";
import Hero from "@/components/sections/Hero";
import AboutTheAuthor from "../components/sections/AboutTheAuthor";
import TypeformWidget from '@/components/ui/TypeformWidget';

export default function Home() {
  return (
    <div className="min-h-screen flex flex-col bg-white font-sans text-gray-800">
      <Navbar />
      <Hero />
      <main>
        <AboutTheAuthor />
        
        {/* Methodology Section with Elevated Iconography */}
        <section className="py-16 bg-indigo-950 text-white">
          <div className="container mx-auto px-4 max-w-5xl">
            <div className="text-center mb-10">
              <h2 className="text-2xl font-serif font-medium mb-4">
                Our Methodology
              </h2>
              <p className="text-sm text-indigo-100 max-w-3xl mx-auto leading-relaxed">
                We bridge the gap between breakthrough science and real-world outcomes—whether you're optimizing your own health 
                or building a practice that delivers it. Our approach rests on three interconnected pillars:
              </p>
            </div>
            
            <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mt-10">
              <div className="border border-indigo-800 bg-indigo-900/50 p-8 rounded-sm relative shadow-lg hover:shadow-xl transition-shadow">
                {/* Elevated Icon Element */}
                <div className="absolute -top-5 left-1/2 transform -translate-x-1/2 bg-indigo-800 w-10 h-10 rounded-sm flex items-center justify-center shadow-md">
                  <p className="text-[13px] font-bold text-white">01</p>
                </div>
                <div className="pt-4">
                  <h3 className="text-base font-medium mb-3 pt-2">Science</h3>
                  <p className="text-sm text-indigo-100 leading-relaxed mb-2">
                    We distill cutting-edge longevity research into high-impact clinical protocols—rooted in evidence, refined through 
                    patient outcomes, and ready for immediate use. This isn't theory. It's translational medicine engineered for action.
                  </p>
                </div>
              </div>
              
              <div className="border border-indigo-800 bg-indigo-900/50 p-8 rounded-sm relative shadow-lg hover:shadow-xl transition-shadow">
                {/* Elevated Icon Element */}
                <div className="absolute -top-5 left-1/2 transform -translate-x-1/2 bg-indigo-800 w-10 h-10 rounded-sm flex items-center justify-center shadow-md">
                  <p className="text-[13px] font-bold text-white">02</p>
                </div>
                <div className="pt-4">
                  <h3 className="text-base font-medium mb-3 pt-2">Operations</h3>
                  <p className="text-sm text-indigo-100 leading-relaxed mb-2">
                    From intake workflows to business dashboards to patient engagement—we build the systems that make advanced care scalable. 
                    You get the infrastructure to deliver precision medicine without sacrificing efficiency, margin, or trust.
                  </p>
                </div>
              </div>
              
              <div className="border border-indigo-800 bg-indigo-900/50 p-8 rounded-sm relative shadow-lg hover:shadow-xl transition-shadow">
                {/* Elevated Icon Element */}
                <div className="absolute -top-5 left-1/2 transform -translate-x-1/2 bg-indigo-800 w-10 h-10 rounded-sm flex items-center justify-center shadow-md">
                  <p className="text-[13px] font-bold text-white">03</p>
                </div>
                <div className="pt-4">
                  <h3 className="text-base font-medium mb-3 pt-2">Innovation</h3>
                  <p className="text-sm text-indigo-100 leading-relaxed mb-2">
                    We track the edge so you don't have to. Our network gives you early access to emerging tools—from regenerative 
                    peptides to AI-driven diagnostics—so your health strategy or clinic model stays one step ahead.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section>
        
        {/* Contact Form Section with Typeform */}
        <section id="contact" className="py-16 bg-gray-50 text-gray-900">
          <div className="container mx-auto px-4 max-w-5xl">
            <div className="mb-10 text-center">
              <h2 className="text-2xl font-serif font-medium mb-2 text-indigo-950">
                Apply for a Longevity Strategy Session
              </h2>
              <div className="h-px bg-indigo-900/20 w-16 mx-auto mb-4"></div>
              <p className="text-sm text-gray-700 max-w-2xl mx-auto mb-6 leading-relaxed">
                Ready to transform your approach to longevity medicine? Fill out the form below to connect with Dr. Vinjamoori.
              </p>
            </div>
            
            <div className="grid md:grid-cols-3 gap-8">
              <div className="md:col-span-3 bg-white p-6 border border-gray-200 shadow-sm">
                <TypeformWidget formId="01JTMDDGCP5TVAC8F11XQ5BKZR" className="min-h-[400px]" />
              </div>
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </div>
  );
}
